<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import noUiSlider from "nouislider";

// The length slider, from short to long. On Auto the handle rests greyed out in the
// middle; sliding or tapping it picks a length.
const store = useStore();

const auto = computed(() => !store.state.length.hasMoved);
const selectedLength = computed(
  () => Number(store.state.length.selectedLength) || 0
);
const position = computed(() => (auto.value ? 2 : selectedLength.value));

const range = ref();
const pipFormats = { 0: "Short", 2: "Medium", 4: "Long" };
let slider;

onMounted(() => {
  slider = noUiSlider.create(range.value, {
    start: position.value,
    connect: [true, false],
    range: {
      min: [0, 1],
      "25%": [1, 1],
      "50%": [2, 1],
      "75%": [3, 1],
      max: [4, 1],
    },
    step: 6,
    pips: {
      mode: "positions",
      values: [0, 50, 100],
      density: 24,
      format: {
        to: function (a) {
          return pipFormats[a];
        },
      },
    },
  });
  // Only the person's own moves pick a length, not the slider being set from here
  const choose = (values) => store.dispatch("length/moveSlider", values[0]);
  slider.on("slide", choose);
  slider.on("change", choose);
});
onBeforeUnmount(() => slider?.destroy());

// Auto, a reset or a page coming back moves the handle to match
watch(position, (value) => {
  if (slider && Number(slider.get()) !== value) slider.set(value);
});
</script>

<template>
  <div class="mx-5" :class="{ 'is-auto': auto }">
    <div ref="range" class="range"></div>
  </div>
</template>
<style>
.range .noUi-handle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  top: -11px;
  right: -15px;
  border: 13px solid #cf5ae2;
  cursor: pointer;
}
.noUi-horizontal {
  height: 6px;
}
.noUi-handle:before,
.noUi-handle:after {
  display: none;
}
.noUi-connect {
  background: #cf5ae2;
  cursor: pointer;
}
.noUi-connects {
  background: #f5f7fb;
  cursor: pointer;
}
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: -5px;
  left: 2px;
  width: 100%;
}
.noUi-value-horizontal:first-child {
  left: 2% !important;
}
.noUi-value {
  font-size: 14px;
}
/* On Auto no length is picked, so the slider steps back */
.is-auto .noUi-connect {
  background: #e4e2ec;
}
.is-auto .range .noUi-handle {
  border-color: #aca8bf;
}
@import "nouislider/dist/nouislider.css";
</style>
